<!-- Breadcrumb -->
<div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
  <h5 class="mb-0">
    <!-- @TODO: arreglar -->
    <!-- Torneo: {{ model.name }}@if (model.event) { - {{ model.event.name }} } -->
    Torneo: {{ model.name }}
  </h5>
  <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
    <li class="breadcrumb-item position-relative">
      <a routerLink="../" class="d-inline-block position-relative">
        <i class="material-symbols-outlined" style="top: 55%;">
          trophy
        </i>
        Torneos
      </a>
    </li>
    <li class="breadcrumb-item position-relative">
      Detalles del torneo
    </li>
  </ol>
</div>

<!-- <div class="row">
  <div class="col-1 d-block d-sm-none">(none)</div>
  <div class="col-sm-1 d-none d-sm-block d-md-none">sm</div>
  <div class="col-md-1 d-none d-md-block d-lg-none">md</div>
  <div class="col-lg-1 d-none d-lg-block d-xl-none">lg</div>
  <div class="col-xl-1 d-none d-xl-block d-xxl-none">xl</div>
  <div class="col-xxl-1 d-none d-xxl-block d-xxxl-none">xxl</div>
  <div class="col-xxxl-1 d-none d-xxxl-block">xxxl</div>
</div> -->

@if (!hasAttemptedLoad()) {
  <div>Init</div>
} @else {
  @if (isLoading()) {
    <div class="big-loading">
      <mat-spinner></mat-spinner>
    </div>
  } @else {
    @if (error()) {
      <div>Error</div>
    } @else {
      <view-ui
        [tournament]="model"
        [drawings]="drawings()"
        [games]="games()"
        [groupsRankings]="groupsRankings()"
        [eventsRankings]="eventsRankings()"
      ></view-ui>
    }
  }
}
